import React from "react";
import { useWallet, useConnection } from '@solana/wallet-adapter-react';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Nightshift from "../_Nightshift";
import PublicSection from '../PublicSection';
import Marketplaces from '../Marketplaces';
import AuctionHouseEvents from './_AuctionHouse_Events';
import AuctionHouseMyRaffles from './_AuctionHouse_MyRaffles';

const tabTheme = createTheme({
  palette: {
    primary: {
      main: '#d63a3a'
    },
    secondary: {
      main: '#111'
    }
  },
  typography: {
    fontFamily: `"Nunito", "Helvetica", "Arial", sans-serif`,
    fontSize: 16,
    button: {
      textTransform: 'none',
    }
  }
});

const domainURL = process.env.REACT_APP_DOMAIN || 'http://localhost:5050/api';

const AuctionHouse = React.forwardRef((nftFunctions, ref) => { 
  const { publicKey, wallet, sendTransaction, signTransaction } = useWallet();
  const [sectionValue, setSectionValue] = React.useState('events');
  const handleSectionChange = (event, newValue) => {
    setSectionValue(newValue);
  };

  return wallet ? (
    <>
      <div>
        <div className="title-bar p-md main-content-wrapper">
          <div className="container main-content-wrapper">
            <h1 className="has-text-white has-font-tomo has-text-shadow">Auction House</h1>
            <Nightshift />
          </div>
        </div>
        <main className="container main-content-wrapper main-wrapper m-t-md">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <ThemeProvider theme={tabTheme}>
                <Box className="m-b-md">
                <Tabs value={sectionValue} onChange={handleSectionChange} aria-label="Grim sections" textColor="secondary" indicatorColor="primary">
                  <Tab value="events" label={`Events`} />
                  <Tab value="my_raffles" label={`My Raffles`} />
                  {/*
                  <Tab value="leaderboard" label={`Leaderboard`} />
                  */}
                </Tabs>
                </Box>
              </ThemeProvider>
            </Grid>
          </Grid>

          {sectionValue == 'events' && <AuctionHouseEvents />}
          {sectionValue == 'my_raffles' && <AuctionHouseMyRaffles />}
          {/*
          {sectionValue == 'leaderboard' && <div></div>}
          */}
        </main>
      </div>
    </>
  ) : (
     <div className="container main-content-wrapper">
      <div className="m-t-md"><PublicSection /></div>
      <Marketplaces />
    </div>
  );
});

export default AuctionHouse;